import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import type { CreditUsageData, CreditUsageMeta } from 'api/dist/routes/organization/[organization_id]/credits/usage'

export interface IGetCreditUsageQueryParams {
    organizationId: string
    page?: number
    limit?: number
}

export class GetCreditUsageQuery {
    static getKey(params: IGetCreditUsageQueryParams) {
        return ['organization', params.organizationId, 'credits', 'usage', { page: params.page, limit: params.limit }]
    }

    static async call(api: IApi, params: IGetCreditUsageQueryParams) {
        const searchParams = new URLSearchParams()
        if (params.page) searchParams.set('page', params.page.toString())
        if (params.limit) searchParams.set('limit', params.limit.toString())

        const queryString = searchParams.toString()
        const url = `/organization/${params.organizationId}/credits/usage${queryString ? `?${queryString}` : ''}`

        return api.get<CreditUsageData, CreditUsageMeta>(url)
    }
}

export const useGetCreditUsageQuery = (
    organizationId: string,
    options?: {
        page?: number
        limit?: number
        enabled?: boolean
    }
) => {
    const api = useClientApi()

    const params: IGetCreditUsageQueryParams = {
        organizationId,
        page: options?.page,
        limit: options?.limit,
    }

    return useApiQuery({
        queryKey: GetCreditUsageQuery.getKey(params),
        queryFn: () => GetCreditUsageQuery.call(api, params),
        enabled: options?.enabled !== false && !!organizationId,
    })
}

export type ICreditUsageData = CreditUsageData
export type ICreditUsageMeta = CreditUsageMeta
